import { SxProps, Theme } from "@mui/material/styles";

export const homeContainer: SxProps<Theme> = {
    width: {
        xs: "100%",
        md: "50%",
    },
    mx: "auto",
};

export const summaryBox: SxProps<Theme> = (theme: Theme) => ({
    p: 3,
    border: 1,
    borderColor: "white",
    borderRadius: "8px",
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.white,
    textAlign: "center",
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
});

export const questionBox: SxProps<Theme> = (theme: Theme) => ({
    p: 2,
    margin: 0.5,
    border: 1,
    borderColor: "white",
    borderRadius: "5px",
    minHeight: "80px",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.white,
});

export const answersGrid: SxProps<Theme> = {
    mt: 2,
    justifyContent: "space-around",
    px: 0.5,
};

export const answerButton: SxProps<Theme> = {
    width: "100%",
    height: "100%",
    minHeight: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "normal",
    textAlign: "center",
    border: 0.5,
};

export const progressBar: SxProps<Theme> = {
    margin: 1,
    mt: 2,
};
